

var trendingProducts = document.querySelectorAll('.trending-products__slide');
for(var i = 0; i < trendingProducts.length; i++){

  trendingProducts[0].classList.add('active');

  trendingProducts[i].addEventListener('click', () => {

  trendingProducts.forEach(el=> {
                    if (el.classList.contains('active')) {
                      el.classList.remove('active');

                    }
                  });
  
    this.classList.add('active');
  });

}
